export const DEFAULT_TUNNEL_URL = '/api/guacamole-tunnel-http'

export interface RemoteConnection {
  label?: string
  url?: string
  tunnelUrl?: string
  connectionToken?: string
}

export interface OpenRemoteOptions {
  title: string
  type?: string
  /** Preferred: guacamole-common-js via app tunnel */
  tunnelUrl?: string
  connectionToken?: string
  /** Fallback: Guacamole web UI (legacy) */
  url?: string
}

export function resolveTunnelUrl(raw?: string | null): string {
  if (!raw) return DEFAULT_TUNNEL_URL
  try {
    if (raw.startsWith('/')) return raw
    const u = new URL(raw, window.location.origin)
    if (u.pathname.includes('guacamole-tunnel')) {
      return `${u.pathname}${u.search}`
    }
  } catch {
    /* ignore */
  }
  return raw
}

export function canOpenEmbedded(opts: {
  tunnelUrl?: string | null
  connectionToken?: string | null
}): boolean {
  return Boolean(opts.connectionToken)
}

/** Keysyms for Ctrl+Alt+Delete */
export const KEYSYM_CTRL = 0xffe3
export const KEYSYM_ALT = 0xffe9
export const KEYSYM_DELETE = 0xffff
